import { render, staticRenderFns } from "./settingsWaterSamplesWidget.vue?vue&type=template&id=d56013b8&scoped=true"
import script from "./settingsWaterSamplesWidget.vue?vue&type=script&lang=js"
export * from "./settingsWaterSamplesWidget.vue?vue&type=script&lang=js"
import style0 from "./settingsWaterSamplesWidget.vue?vue&type=style&index=0&id=d56013b8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d56013b8",
  null
  
)

export default component.exports